import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { TextFieldElement } from 'react-hook-form-mui';
import { useTranslation } from 'react-i18next';

/* eslint-disable react/require-default-props */
interface CharCountTextFieldProps {
  name: string;
  label: string;
  maxLength: number;
  warningThreshold: number;
  required?: boolean;
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
  testId: string;
}

function CharCountTextField({
  name,
  label,
  maxLength,
  warningThreshold,
  required = false,
  multiline = false,
  rows,
  disabled = false,
  testId,
}: CharCountTextFieldProps) {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  const [charCount, setCharCount] = useState(maxLength);
  const [color, setColor] = useState<'warning' | undefined>(undefined);

  const fieldValue = watch(name);

  // Calculate character count and color on every render
  // This component will only re-render when its field changes
  const valueLength = fieldValue?.length || 0;
  const remainingChars = maxLength - valueLength;
  const shouldShowWarning = valueLength >= warningThreshold;

  // Update state only if changed to avoid unnecessary re-renders
  if (remainingChars !== charCount) {
    setCharCount(remainingChars);
  }
  if ((shouldShowWarning ? 'warning' : undefined) !== color) {
    setColor(shouldShowWarning ? 'warning' : undefined);
  }

  return (
    <TextFieldElement
      name={name}
      label={label}
      variant='standard'
      fullWidth
      required={required}
      multiline={multiline}
      rows={rows}
      disabled={disabled}
      inputProps={{ 'data-testid': testId, maxLength }}
      helperText={t('inventory.recipeDetailsPage.nameHelperText', {
        length: charCount,
      })}
      color={color}
    />
  );
}

export default CharCountTextField;
